import { createSelector } from "@reduxjs/toolkit";

const exportDataSelector = createSelector(
  (state) => state.exportData,
  (a) => a
);

export default exportDataSelector;
